import { render, staticRenderFns } from "./IssueEcoMemberCardDialog.vue?vue&type=template&id=4df2278f&"
import script from "./IssueEcoMemberCardDialog.vue?vue&type=script&lang=js&"
export * from "./IssueEcoMemberCardDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports